import { initConfigUnsafe } from '@cian/config/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initUpdateLegalCheckService } from '../../shared/services/legalCheck';
import { initWebview } from '@cian/webview/webview';

export function initDependencies(): void {
  initConfigUnsafe();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initUpdateLegalCheckService();
  initWebview();
}
